/* unplugin-vue-components disabled */import script from "./searchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__